import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.quiz.setting');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-quiz-setting',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.quiz.setting/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}`],
})
export class PageQuizSettingComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public subjects: any[] = [];
    public loading: boolean = true;

    // 설정
    public config: any = {
        subject_id: '',
        chapter_ids: [] as string[],
        question_count: 20,
        difficulty_min: 1,
        difficulty_max: 6,
        time_limit: 0,
        mode: 'practice',
        question_types: [] as string[],
        source_types: [] as string[]
    };

    public availableCount: number = 0;
    public starting: boolean = false;

    public questionTypes = [
        { value: 'multiple_choice', label: '5지선다' },
        { value: 'ox', label: 'OX' },
        { value: 'ordering', label: '순서배열' },
        { value: 'matching', label: '연결하기' },
        { value: 'short_answer', label: '단답형' }
    ];

    public sourceTypes = [
        { value: 'suneung', label: '수능 기출' },
        { value: 'mockexam', label: '모의고사' },
        { value: 'qualification', label: '한국사능력검정' },
        { value: 'textbook', label: '교과서' },
        { value: 'self', label: '자체 출제' }
    ];

    public difficulties = [
        { value: 1, label: '1 (매우 쉬움)' },
        { value: 2, label: '2 (쉬움)' },
        { value: 3, label: '3 (보통)' },
        { value: 4, label: '4 (어려움)' },
        { value: 5, label: '5 (매우 어려움)' },
        { value: 6, label: '6 (최상)' }
    ];

    public timeLimits = [
        { value: 0, label: '제한 없음' },
        { value: 600, label: '10분' },
        { value: 1200, label: '20분' },
        { value: 1800, label: '30분' },
        { value: 2700, label: '45분' },
        { value: 3600, label: '60분' },
        { value: 5400, label: '90분 (수능)' }
    ];

    public questionCounts = [5, 10, 15, 20, 25, 30, 40, 50];

    public async ngOnInit() {
        await this.service.init();

        // URL 쿼리 파라미터 읽기
        const params = new URLSearchParams(window.location.search);
        if (params.get('subject')) this.config.subject_id = params.get('subject')!;
        if (params.get('chapter')) this.config.chapter_ids = [params.get('chapter')!];

        await this.loadSubjects();
        if (this.config.subject_id) await this.checkAvailable();
        this.loading = false;
        await this.service.render();
    }

    public async loadSubjects() {
        let res = await wiz.call("subjects");
        if (res.code === 200) this.subjects = res.data.subjects || [];
    }

    public get selectedSubject(): any {
        return this.subjects.find(s => s.id === this.config.subject_id);
    }

    public get chapters(): any[] {
        return this.selectedSubject?.chapters || [];
    }

    public async onSubjectChange() {
        this.config.chapter_ids = [];
        await this.checkAvailable();
        await this.service.render();
    }

    public toggleChapter(id: string) {
        const idx = this.config.chapter_ids.indexOf(id);
        if (idx >= 0) this.config.chapter_ids.splice(idx, 1);
        else this.config.chapter_ids.push(id);
        this.checkAvailable();
        this.service.render();
    }

    public selectAllChapters() {
        if (this.config.chapter_ids.length === this.chapters.length) {
            this.config.chapter_ids = [];
        } else {
            this.config.chapter_ids = this.chapters.map(c => c.id);
        }
        this.checkAvailable();
        this.service.render();
    }

    public toggleQuestionType(v: string) {
        const idx = this.config.question_types.indexOf(v);
        if (idx >= 0) this.config.question_types.splice(idx, 1);
        else this.config.question_types.push(v);
        this.checkAvailable();
        this.service.render();
    }

    public toggleSourceType(v: string) {
        const idx = this.config.source_types.indexOf(v);
        if (idx >= 0) this.config.source_types.splice(idx, 1);
        else this.config.source_types.push(v);
        this.checkAvailable();
        this.service.render();
    }

    public async onDifficultyChange() {
        await this.checkAvailable();
        await this.service.render();
    }

    public async checkAvailable() {
        if (!this.config.subject_id) { this.availableCount = 0; return; }
        let res = await wiz.call("available_count", {
            subject_id: this.config.subject_id,
            chapter_ids: JSON.stringify(this.config.chapter_ids),
            difficulty_min: String(this.config.difficulty_min),
            difficulty_max: String(this.config.difficulty_max),
            question_types: JSON.stringify(this.config.question_types),
            source_types: JSON.stringify(this.config.source_types)
        });
        if (res.code === 200) this.availableCount = res.data.count || 0;
        await this.service.render();
    }

    public async startQuiz() {
        if (!this.config.subject_id) {
            await this.service.alert.show({ title: '알림', message: '과목을 선택해주세요.' });
            return;
        }
        if (this.availableCount === 0) {
            await this.service.alert.show({ title: '알림', message: '출제 가능한 문제가 없습니다.' });
            return;
        }
        this.starting = true;
        await this.service.render();

        let res = await wiz.call("start", {
            subject_id: this.config.subject_id,
            chapter_ids: JSON.stringify(this.config.chapter_ids),
            question_count: String(this.config.question_count),
            difficulty_min: String(this.config.difficulty_min),
            difficulty_max: String(this.config.difficulty_max),
            time_limit: String(this.config.time_limit),
            mode: this.config.mode,
            question_types: JSON.stringify(this.config.question_types),
            source_types: JSON.stringify(this.config.source_types)
        });

        if (res.code === 200) {
            this.service.href('/quiz/play/' + res.data.exam_id);
        } else {
            await this.service.alert.show({ title: '오류', message: res.data?.message || '시험 생성 실패' });
        }
        this.starting = false;
        await this.service.render();
    }
}

export default PageQuizSettingComponent;